const handlePriceChange = (value: string, isZeroBasedPricing: boolean) => {
  const numValue = parseFloat(value);
  const PRICE_LIMITS = {
    zeroBased: { min: -20, max: 20 },
    standard: { min: 80, max: 120 },
  } as const;

  const { min, max } = isZeroBasedPricing
    ? PRICE_LIMITS.zeroBased
    : PRICE_LIMITS.standard;

  if (Number.isNaN(numValue)) {
    return {
      hasError: true,
      errorMessage: `Please enter price between ${min} and ${max}`,
    };
  }

  if (numValue < min || numValue > max) {
    return {
      hasError: true,
      errorMessage: `Please enter price between ${min} and ${max}`,
    };
  }
  return {
    hasError: false,
    errorMessage: '',
  };
};

const handleRateChange = (value) => {
  if (
    Number.isNaN(parseFloat(value)) ||
    parseFloat(value) < 0 ||
    parseFloat(value) > 20
  ) {
    return {
      hasError: true,
      errorMessage: 'Please enter rate between 0 and 20',
    };
  }
  return {
    hasError: false,
    errorMessage: '',
  };
};

const handleDaysChange = (value) => {
  if (
    Number.isNaN(parseFloat(value)) ||
    parseInt(value, 10) < 1 ||
    parseInt(value, 10) > 30
  ) {
    return {
      hasError: true,
      errorMessage: 'Please provide expiration between 1 and 30 days',
    };
  }
  return {
    hasError: false,
    errorMessage: '',
  };
};

const handleEmailChange = (value) => {
  if (
    value !== undefined &&
    value.trim() !== '' &&
    !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)
  ) {
    return {
      hasError: true,
      errorMessage: 'Please provide valid email',
    };
  }
  return {
    hasError: false,
    errorMessage: '',
  };
};

export {
  handlePriceChange,
  handleRateChange,
  handleDaysChange,
  handleEmailChange,
};
